(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('CustomUpdatesController', CustomUpdatesController);

    CustomUpdatesController.$inject = ['$scope', '$state', 'TabFleets', 'ListObjAndObjType', 'paginationConstants', 'ParseLinks',
        'AlertService', 'ListObjByObjTypeAndFleet', 'SetScheduleForAll', '$uibModal', 'ObjectStatusService', 'TabUpdateScripts'];

    function CustomUpdatesController($scope, $state, TabFleets, ListObjAndObjType, paginationConstants, ParseLinks,
                                     AlertService, ListObjByObjTypeAndFleet, SetScheduleForAll, $uibModal, ObjectStatusService, TabUpdateScripts) {
        var vm = this;
        vm.loadPage = loadPage;
        vm.changePageSize = changePageSize;
        vm.transition = transition;
        vm.predicates = {};
        vm.tabObjectsRow = [];
        vm.areChk = false;
        vm.tabFleets = [];
        vm.isOpen = false;
        vm.objectToUdp = [];
        vm.currentPage = 1;
        vm.date = new Date();
        vm.charToSearch = '';
        vm.onlyToUpdate = false;
        vm.onlyOnline = false;
        vm.checkNextPages = false;
        vm.pagesChecked = [];
        vm.selection = {};
        vm.selection.fleet = -1;
        vm.selection.objectType = -1;
        vm.currentState = "custom-update";
        vm.tabUpdateScripts = [];
        vm.numberObjects = 0;
        vm.forced = false;
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder != "null")
            vm.predicates = JSON.parse(retrievedOrder);
        vm.commands = $state.params.commands;
        vm.tag = null;
        vm.timepickerOptions = {showMeridian: false};

        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;
        ObjectStatusService.init();

        var query = {};

        $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState) {
            if (toState.name == vm.currentState && toState.name != fromState.name) {
                ObjectStatusService.connect();
                ObjectStatusService.subscribe(function () {
                    ObjectStatusService.sendChangePage({
                        page: vm.currentPage - 1,
                        size: vm.itemsPerPageChosen,
                        sort: sort(),
                        query: vm.charToSearch
                    });
                });


            } else if (fromState.name == vm.currentState && toState.name != fromState.name) {
                ObjectStatusService.unsubscribe();
                ObjectStatusService.disconnect();
            }
        });

        //caricamento delle flotte all'atterraggio in pagina
        TabFleets.query({}, onTabFleetsSuccess, onError);

        function onTabFleetsSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            for (var i = 0; i < data.length; i++) {
                vm.tabFleets.push(data[i]);
            }
            if (data.length === 1) {
                vm.selectedFleet(data[0], 1, true);
            }
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        //check e uncheck di tutti gli elementi in pagina
        vm.chkUnChkAll = function () {
            if (vm.areChk) {
                resetParams();
            } else {
                vm.areChk = true;
                vm.objectToUdp = [];
                // pushAllObject();
                addAllToUpdate(false).then(function () {
                    $state.go('custom-update', null, {reload: false});
                });
            }
        };


        function pushAllObject() {
            vm.checkNextPages = true;
            if (vm.pagesChecked.indexOf(vm.currentPage - 1) < 0 || vm.areChk) {
                $.each(vm.tabObjectsRow, function (key, el) {
                    if (findIndex(el) < 0) {
                        vm.objectToUdp.push(el);
                    }
                });
                vm.pagesChecked.push(vm.currentPage - 1);
            }
        }

        function resetParams() {
            vm.areChk = false;
            vm.checkNextPages = false;
            vm.pagesChecked = [];
            if (vm.objectToUdp.length > vm.numberObjects) {
                addAllToUpdate(true).then(function () {
                    $state.go('custom-update', null, {reload: false});
                });
            } else {
                vm.objectToUdp = [];
            }
        }

        /* selezionata la flotta popolo la select degli object type e la lista degli object in pagina
         annullando l'eventuale selezione di questi ultimi */
        vm.selectedFleet = function (fleet, currentPage, uncheckAll) {
            if (vm.selection.fleet != fleet.id) {
                resetParams();
                vm.tabObjectsRow = [];
                vm.totalItems = 0;
                vm.queryCount = 0;
                vm.selection.fleet = fleet.id;
                vm.numberObjects = 0;
            }
            query = {
                id: fleet.id,
                fleetId: fleet.id,
                query: vm.charToSearch,
                onlyUpdate: vm.onlyToUpdate,
                onlyOnline: vm.onlyOnline,
                page: currentPage - 1,
                size: vm.itemsPerPageChosen,
                sort: sort()
            };
            ListObjAndObjType.query(query, onSuccess, onError);

            function sort() {
                var sortFields = [];
                var keys = Object.keys(vm.predicates);
                for (var key in keys) {
                    var predicate = keys[key];
                    sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc'));
                }
                localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
                return sortFields;
            }

            function onSuccess(data, headers) {
                vm.tabObjectType = (data.tabObjectTypesList);
                vm.fleet = fleet;
                //reset delle due select dipendenti dalla flotta e forzatura della pagina 0 in tabella
                vm.objType = null;
                vm.currentPage = currentPage;
                ObjectStatusService.sendChangePage(query);
                transition(false);
                if (data.tabObjectTypesList.length === 1) {
                    vm.objType = data.tabObjectTypesList[0]
                    vm.selectObjectType(vm.objType, 1, true)
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc'));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        /* selezionato l'object type popolo la select e lista degli object in pagina
         annullando l'eventuale selezione di quest' ultimo */
        vm.selectObjectType = function (objType, currentPage, uncheckAll, script) {
            if (vm.selection.objectType != objType.id) {
                vm.pagesChecked = [];
                vm.checkNextPages = false;
                vm.selection.objectType = objType.id;
                vm.numberObjects = 0;
            }
            query = {
                typeId: objType.id,
                fleetId: vm.fleet.id,
                query: vm.charToSearch,
                onlyUpdate: vm.onlyToUpdate,
                onlyOnline: vm.onlyOnline,
                page: currentPage - 1,
                size: vm.itemsPerPageChosen,
                sort: sort()
            };
            ListObjByObjTypeAndFleet.query(query, onSuccess, onError);

            TabUpdateScripts.query({
                page: 0,
                size: 1000,
                objectType: vm.objType.id
            }, onSuccessScript);


            function onSuccessScript(data) {
                vm.tabUpdateScripts = data;
            }

            function onSuccess(data, headers) {
                vm.tabObjectsRow = data;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;

                // if (vm.numberObjects === 0)
                vm.numberObjects = parseInt(vm.totalItems);

                areAllObjectChecked();
                //popolamento tabella
                if (uncheckAll) {
                    vm.objectToUdp = [];
                }
                if (vm.areChk || vm.checkNextPages)
                    pushAllObject();
                // forzo la prima pagina della tabella
                vm.currentPage = currentPage;
                ObjectStatusService.sendChangePage(query);
                transition(false);
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        vm.deselectObjTy = function (obj) {
            var reload = vm.objType;
            vm.objType = null;
            if (reload != null)
                loadPage(vm.currentPage);
        };

        function findIndex(obj) {
            return vm.objectToUdp.findIndex(function (el) {
                return el.objectUniqueCode === obj.objectUniqueCode;
            });
        }

        vm.toggleSelection = function (data) {
            var idx = findIndex(data);
            if (idx > -1) {
                vm.objectToUdp.splice(idx, 1);
                vm.areChk = false;
            } else {
                vm.objectToUdp.push(data);
                areAllObjectChecked();
            }
        };

        function areAllObjectChecked() {
            if (vm.objectToUdp.length >= vm.numberObjects) {
                vm.areChk = true;
            } else {
                vm.areChk = false;
            }
        }

        function addAllToUpdate(isToRemove) {
            return new Promise(function (resolve, reject) {
                // if (vm.areChk) {
                    query = {
                        typeId: vm.selection.objectType,
                        fleetId: vm.fleet.id,
                        query: vm.charToSearch,
                        onlyUpdate: vm.onlyToUpdate,
                        onlyOnline: vm.onlyOnline,
                        page: 0,
                        size: vm.totalItems,
                        sort: sort()
                    };
                    ListObjByObjTypeAndFleet.query(query, onSuccess, onError);

                    function onSuccess(d, h) {
                        if (!isToRemove) {
                            vm.objectToUdp = d;
                        } else {
                            $.each(d, function (key, object) {
                                vm.objectToUdp.splice(findIndex(object), 1);
                            })
                        }
                        resolve();
                    }

                    function onError() {
                        console.log("Error all update");
                    }
                // } else {
                //     resolve();
                // }
            })
        }

        vm.openCalendar = function (e, prop, el) {
            e.preventDefault();
            e.stopPropagation();
            if (vm[el]) {
                vm[el].isOpen = !vm[el].isOpen;
            } else {
                vm[el] = {isOpen: true};
            }

        };

        vm.configureUpdates = function () {
            query.all = vm.areChk;
            query.updateFirmware = vm.updFirmware
            SetScheduleForAll.update(query, {
                scheduleDatetime: vm.date,
                tabObjects: vm.areChk ? [] : vm.objectToUdp,
                command: vm.commands,
                tag: vm.tag,
                forced: vm.forced
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.tabObjectsRow = [];
                vm.fleet = null;
                vm.objType = null;
                vm.obj = null;
                vm.areChk = false;
                vm.commands = null;
                vm.tag = null;
                vm.forced = false;
            }


            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        vm.openModalCommand = function () {
            $uibModal.open({

                templateUrl: 'app/management/custom-update/custom-update-dialog.html',
                controller: 'CustomUpdatesDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    scripts: function () {
                        return vm.tabUpdateScripts;
                    }
                }
            }).result.then(function (newCommands) {
                vm.commands = newCommands;
            });
        };

        // modal for tag on updates processes
        vm.openModalForTag = function () {
            $uibModal.open({
                templateUrl: 'app/management/custom-update/custom-update-tags-dialog.html',
                controller: 'CustomUpdateTagsDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    numObjects: function () {
                        return vm.areChk ? vm.totalItems : vm.objectToUdp.length;
                    },
                    schedule: false
                }
            }).result.then(function (data) {
                vm.tag = data.tag;
                vm.updFirmware = data.updFirmware;
                if (data.date) {
                    vm.date = data.date;
                }
                vm.forced = data.forced;
                vm.configureUpdates();
            });
        };

        function loadPage(page) {
            vm.currentPage = page;
            transition(true, false);
        }

        vm.search = function () {
            // resetParams();
            vm.currentPage = 1;
            var reset = false;
            // if(!vm.areChk)
            //     reset = true;
            transition(true, reset);
        };

        function transition(recall, reset) {
            //eseguo la chiamata in base alle opzioni già selezionate
            if (recall) {
                if (vm.objType) {
                    vm.selectObjectType(vm.objType, vm.currentPage, reset);
                } else {
                    vm.selectedFleet(vm.fleet, vm.currentPage, reset);
                }
            }
            $state.transitionTo($state.$current, {
                page: vm.currentPage,
                predicates: vm.predicates,
                sort: sort(),
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen
            }, {notify: false, reload: false, location: "replace"});
        }

        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < vm.currentPage)
                vm.currentPage = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition(true);
        }

        vm.checkChecked = function (obj) {
            var idx = findIndex(obj);
            return idx > -1;
        };
    }

})();
